import React from 'react'

import { buildComponent } from 'src/components/factory'
import { useAudioConfiguration } from 'src/hooks/use-audio-configuration'

import * as Elements from 'src/components/elements'

export const ScreenConnectedAudioBackgrounds = buildComponent()
  .withLocale('screens.connected.audio-backgrounds.screen')
  .withLifecycle(() => {
    const configuration = useAudioConfiguration()
    const isBackgroundCategory = configuration.categoryType === 'background'
    
    return { isBackgroundCategory }
  })
  .withRender(({ locale, lifecycle }) => {
    const title = lifecycle.isBackgroundCategory ? '' : locale('title')
    
    return (
      <Elements.AudioView
        summary
        title={title}
        redirect={{
          to: '/audio/durations',
          with: (constraints) => {
            // Si on a un livre et que seule l'option "Aucun fond sonore" est disponible
            if (constraints.book && constraints.backgrounds.length === 0) {
              return { background: 'no-background' }
            }
            // Logique existante pour un seul arrière-plan disponible
            return {
              background: constraints.backgrounds[0]?.slug,
            }
          },
          when: (constraints) => {
            // Si on a un livre et aucun arrière-plan disponible (donc seulement noBackgroundOption)
            if (constraints.book && constraints.backgrounds.length === 0) {
              return true
            }
            // Logique existante pour un seul arrière-plan disponible
            return (
              constraints.backgrounds.length === 1 &&
              !!constraints.backgrounds[0]?.slug
            )
          },
        }}
      >
        {(constraints) => {
          // L'option "Aucun fond sonore" n'apparaît que si on a sélectionné un thème ou un livre
          // (pas dans la catégorie "musique" pure)
          const showNoBackground = !!constraints.theme || !!constraints.book

          if (!showNoBackground) {
            return constraints.backgrounds.map((background) => (
              <Elements.AudioOptionBackground
                key={background._id}
                background={background}
              />
            ))
          }

          // Créer l'option "Aucun fond sonore"
          const noBackgroundOption = {
            _id: 'no-background',
            slug: 'no-background',
            short: { fr: 'Aucun', en: 'None' },
            long: { fr: 'Aucun fond sonore', en: 'No background sound' },
            tracks: { 10: 1, 15: 1, 20: 1, 25: 1, 30: 1 },
            mode: 'always' as const,
          }

          return (
            <>
              <Elements.AudioOptionBackground
                key={noBackgroundOption._id}
                background={noBackgroundOption}
              />
              {constraints.backgrounds.map((background) => (
                <Elements.AudioOptionBackground
                  key={background._id}
                  background={background}
                />
              ))}
            </>
          )
        }}
      </Elements.AudioView>
    )
  })
